if($('#products-5').length){

$("#products-5").closest(".content-wrapper").insertBefore($(".homepage-box.middle-banners-wrapper"));


}

if($('.welcome>div>p img[style="float: left;"]').length){
    $('.footer-banners').before($('.homepage-box.welcome-wrapper'));
    $('.welcome').before($('.welcome>div>p img[style="float: left;"]').closest('p'))
}